module.exports = __webpack_public_path__ + "img/asian-vegetables-1.f591ff61.jpg";